import React from 'react';
import { Trophy, Briefcase, X, Check } from 'lucide-react';
export function PackEliteComparison() {
  return <section className="bg-white py-8 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <div className="text-center mb-6 sm:mb-12" data-id="element-186">
          <h2 className="text-3xl sm:text-4xl font-black text-deep mb-4" data-id="element-187">
            ¿Qué agrega el Pack Élite™?
          </h2>
          <p className="text-lg text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-188">
            El sistema para profes que no solo quieren enseñar — quieren crecer
            y construir un negocio acuático
          </p>
        </div>

        <div className="space-y-6 sm:space-y-12" data-id="element-189">
          {/* Natación Competitiva */}
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-190">
            <div className="bg-deep p-4 sm:p-6 text-center" data-id="element-191">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/10 mb-3" data-id="element-192">
                <Trophy className="w-6 h-6 text-turquoise" data-id="element-193" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2" data-id="element-194">
                NATACIÓN COMPETITIVA: DE LA PILETA AL TORNEO
              </h3>
              <p className="text-turquoise italic font-medium" data-id="element-195">
                "Todo lo que necesitás para preparar nadadores para competencia"
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-200" data-id="element-196">
              <div className="p-4 sm:p-6 bg-red-50/50" data-id="element-197">
                <h4 className="font-bold text-red-800 mb-4 text-center text-sm uppercase tracking-wider" data-id="element-198">
                  Sin Pack Élite
                </h4>
                <ul className="space-y-3 sm:space-y-4" data-id="element-199">
                  <li className="flex items-start gap-3" data-id="element-200">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-201" />
                    <span className="text-sm text-gray-700" data-id="element-202">
                      No sabés cómo estructurar un entrenamiento orientado a
                      competencia
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-203">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-204" />
                    <span className="text-sm text-gray-700" data-id="element-205">
                      Tus nadadores avanzados sienten que no tienen un desafío
                      real
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-206">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-207" />
                    <span className="text-sm text-gray-700" data-id="element-208">
                      No tenés material para trabajar con nadadores que quieren
                      más
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-209">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-210" />
                    <span className="text-sm text-gray-700" data-id="element-211">
                      No sabés cómo preparar a un alumno para su primera
                      competencia
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-212">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-213" />
                    <span className="text-sm text-gray-700" data-id="element-214">
                      Tus alumnos avanzados se aburren y abandonan
                    </span>
                  </li>
                </ul>
              </div>

              <div className="p-4 sm:p-6 bg-green-50/50" data-id="element-215">
                <h4 className="font-bold text-green-800 mb-4 text-center text-sm uppercase tracking-wider" data-id="element-216">
                  Con Pack Élite
                </h4>
                <ul className="space-y-3 sm:space-y-4" data-id="element-217">
                  <li className="flex items-start gap-3" data-id="element-218">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-219" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-220">
                      10 sesiones de entrenamiento competitivo listas para usar
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-221">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-222" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-223">
                      Periodización específica para torneos distribuida en el
                      mes
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-224">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-225" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-226">
                      Técnica de largadas, virajes y nado de competencia paso a
                      paso
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-227">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-228" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-229">
                      Protocolo completo de preparación pre-competencia
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-230">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-231" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-232">
                      Clases desafiantes que generan fidelidad y resultados
                      concretos
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Escuela de Natación Rentable */}
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-233">
            <div className="bg-deep p-4 sm:p-6 text-center" data-id="element-234">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/10 mb-3" data-id="element-235">
                <Briefcase className="w-6 h-6 text-turquoise" data-id="element-236" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2" data-id="element-237">
                CÓMO MONTAR TU ESCUELA DE NATACIÓN RENTABLE
              </h3>
              <p className="text-turquoise italic font-medium" data-id="element-238">
                "Tu hoja de ruta para dejar de intercambiar tiempo por dinero"
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-200" data-id="element-239">
              <div className="p-4 sm:p-6 bg-red-50/50" data-id="element-240">
                <h4 className="font-bold text-red-800 mb-4 text-center text-sm uppercase tracking-wider" data-id="element-241">
                  Sin Pack Élite
                </h4>
                <ul className="space-y-3 sm:space-y-4" data-id="element-242">
                  <li className="flex items-start gap-3" data-id="element-243">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-244" />
                    <span className="text-sm text-gray-700" data-id="element-245">
                      No tenés un sistema estructurado para ofrecer como
                      propuesta profesional
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-246">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-247" />
                    <span className="text-sm text-gray-700" data-id="element-248">
                      No sabés cuánto cobrar ni cómo justificar tus tarifas
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-249">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-250" />
                    <span className="text-sm text-gray-700" data-id="element-251">
                      No tenés forma de mostrar resultados concretos a tu
                      institución o alumnos
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-252">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-253" />
                    <span className="text-sm text-gray-700" data-id="element-254">
                      No sabés cómo captar nuevos alumnos de forma sistemática
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-255">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-256" />
                    <span className="text-sm text-gray-700" data-id="element-257">
                      Tus alumnos no sienten que forman parte de algo
                      estructurado
                    </span>
                  </li>
                </ul>
              </div>

              <div className="p-4 sm:p-6 bg-green-50/50" data-id="element-258">
                <h4 className="font-bold text-green-800 mb-4 text-center text-sm uppercase tracking-wider" data-id="element-259">
                  Con Pack Élite
                </h4>
                <ul className="space-y-3 sm:space-y-4" data-id="element-260">
                  <li className="flex items-start gap-3" data-id="element-261">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-262" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-263">
                      Estructura completa de escuela de natación lista para
                      implementar
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-264">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-265" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-266">
                      Modelo de precios por nivel, edad y modalidad con
                      criterios claros
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-267">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-268" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-269">
                      Fichas de progreso y sistema de evaluación para evidenciar
                      mejoras reales
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-270">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-271" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-272">
                      Estrategias de marketing local y digital para llenar tus
                      horarios
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-273">
                    <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-274" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-275">
                      Sistema de niveles y certificados que generan pertenencia
                      y compromiso
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}